import React from 'react';
import { X } from 'lucide-react';

// Modal simples sem Radix UI - evita conflitos de portais
export const SimpleModal = ({ open, onClose, title, children, footer, maxWidth = 'max-w-md', className = '' }) => {
  if (!open) return null;
  
  // Prevenir propagação de cliques dentro do modal
  const handleContentClick = (e) => {
    e.stopPropagation();
  };
  
  // Usar className se fornecido, senão usar maxWidth
  const widthClass = className || maxWidth;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true">
      {/* Backdrop - z-index menor */}
      <div 
        className="fixed inset-0 bg-black/50 transition-opacity z-40" 
        onClick={onClose}
        aria-hidden="true"
      />
      {/* Conteúdo do modal - z-index maior */}
      <div 
        className={`relative bg-white rounded-lg shadow-xl ${widthClass} w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col z-50`}
        onClick={handleContentClick}
      >
        <div className="flex items-center justify-between p-4 border-b shrink-0">
          <h2 className="text-lg font-semibold" style={{ fontFamily: 'Manrope, sans-serif' }}>{title}</h2>
          <button 
            type="button"
            onClick={onClose} 
            className="p-1 hover:bg-slate-100 rounded transition-colors"
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 overflow-y-auto flex-1">
          {children}
        </div>
        {footer && (
          <div className="p-4 border-t shrink-0 flex justify-end gap-2">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default SimpleModal;
